import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { ArrowLeftIcon, LayoutIcon, CodeIcon, SmartphoneIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const TeamLid3Page: React.FC = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white font-sans text-[#111827]" data-id="element-2127">
      <SEO data-id="element-2128" />
      <Header data-id="element-2129" />

      <main className="pt-32 pb-20 lg:pt-40 lg:pb-24" data-id="element-2130">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2131">
          <button onClick={() => navigate('/over-ons')} className="inline-flex items-center gap-2 text-[#004AC7] font-medium hover:underline mb-12" data-id="element-2132">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-2133" /> Terug naar het team
          </button>

          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-2134">
            <div className="lg:w-1/3 flex justify-center lg:justify-start" data-id="element-2135">
              <div className="w-[300px] h-[300px] rounded-full border-4 border-[#004AC7] overflow-hidden shadow-lg" data-id="element-2136">
                <img src="https://cdn.magicpatterns.com/uploads/gwFh8VhGW156sUNRdzC2Ac/image.png" alt="Alex" className="w-full h-full object-cover" style={{
                objectPosition: 'center 35%'
              }} data-id="element-2137" />
              </div>
            </div>

            <div className="lg:w-2/3" data-id="element-2138">
              <h1 className="text-4xl md:text-5xl font-bold text-[#111827] mb-2" data-id="element-2139">
                Alex
              </h1>
              <p className="text-xl text-[#607697] font-medium mb-8" data-id="element-2140">
                Developer
              </p>

              <div className="prose prose-lg text-[#4B5563] mb-12" data-id="element-2141">
                <p className="mb-4" data-id="element-2142">
                  Als Developer bouw ik de websites en webapplicaties van Noord
                  Digital. Ik vertaal de strategische visie van CorePrint naar
                  snelle, gebruiksvriendelijke en conversiegerichte websites die
                  perfect passen bij de merkidentiteit van onze klanten.
                </p>
                <p className="mb-4" data-id="element-2143">
                  Mijn focus ligt op het creëren van naadloze
                  gebruikerservaringen (UX) en strakke interfaces (UI). Een
                  website moet er niet alleen fantastisch uitzien, maar ook
                  intuïtief werken op elk apparaat en razendsnel laden.
                </p>
                <p data-id="element-2144">
                  Ik bouw robuuste, schaalbare oplossingen in WordPress, waarbij
                  ik altijd rekening houd met de nieuwste webstandaarden,
                  toegankelijkheid en technische SEO-vereisten.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-[#111827] mb-6" data-id="element-2145">
                Expertise
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-2146">
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2147">
                  <LayoutIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2148" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2149">WordPress</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2150">
                  <SmartphoneIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2151" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2152">UI/UX Design</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2153">
                  <CodeIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2154" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2155">
                    Frontend Development
                  </h3>
                </div>
              </div>

              <a href="/#contact" className="inline-block bg-[#004AC7] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#003A9E] transition-colors shadow-md" data-id="element-2156">
                Neem contact op met Alex
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-2157" />
    </div>;
};